import { BookBoxForm } from "./BookForm";
import { boxContent, dataCompany, termData } from "./data";
import { Modal } from "./modal";
import { ICompanyBox, TState, TTerm } from "./types";

function BoxRender(areasData: ICompanyBox[], onChange: (value: number) => void) {
  const areas = areasData

  const calculateBoxWrapper = document.getElementById('calculateBoxWrapper');
  if (!calculateBoxWrapper) return;

  const box = document.createElement('div')
  box.classList.add('calculate-box')

  const area = document.createElement('div')
  area.classList.add("calc-area")

  box.appendChild(area)

  let cl = '';

  const setSize = (v: number) => {
    if (cl) res.classList.remove(cl)
    cl = `ca${areas[v].cr}`
    res.classList.add(cl)
    res.innerText = `${areas[v].sq}м²`
  }

  const handleClick = (index: number) => {
    setSize(index)
    onChange(index)
  }

  areas.forEach((e, index) => {
    const el = document.createElement('div')
    el.classList.add('ca')
    el.classList.add('a-' + e.ca)
    el.addEventListener('click', () => handleClick(index))
    area.appendChild(el)
  })

  const res = document.createElement('div');
  res.classList.add('calc-result')
  box.appendChild(res)

  calculateBoxWrapper.appendChild(box)

  return { setSize }
}








function TermsRender(onChange: (value: TTerm) => void) {
  const terms = termData

  const calculateTerms = document.getElementById('calculateTerms');
  if (!calculateTerms) return;

  let active = 0, buttons: HTMLButtonElement[] = [];

  const handleClick = (index: number, value: TTerm) => {
    if (active === index) return;

    buttons[active].classList.remove('active');
    active = index;
    buttons[active].classList.add('active');
    // buttons.forEach((b,i)=>{})
    onChange(value)
  }

  terms.forEach((e, index) => {
    const el = document.createElement('button')
    el.classList.add('option-btn')
    if (index == active) el.classList.add('active')

    el.addEventListener('click', () => handleClick(index, e))
    el.innerText = e.name
    buttons.push(el)
    calculateTerms.appendChild(el)
  })

}






function SizesRender(areasData: ICompanyBox[], onChange: (value: number) => void) {
  const areas = areasData

  const calculateSize = document.getElementById('calculateSize');
  if (!calculateSize) return;

  let active = 0, buttons: HTMLButtonElement[] = [];

  const setSize = (v: number) => {
    if (active === v) return;

    buttons[active].classList.remove('active');
    active = v;
    buttons[active].classList.add('active');
  }


  const handleClick = (index: number) => {
    if (active === index) return;

    buttons[active].classList.remove('active');
    active = index;
    buttons[active].classList.add('active');
    // buttons.forEach((b,i)=>{})
    onChange(index)
  }

  areas.forEach((e, index) => {
    const el = document.createElement('button')
    el.classList.add('option-btn')
    if (index == active) el.classList.add('active')

    el.addEventListener('click', () => handleClick(index))
    el.innerText = `${e.sq}`
    buttons.push(el)
    calculateSize.appendChild(el)
  })

  return { setSize }
}








const renderSummary = (box: ICompanyBox, profit: number, total: number, state: TState) => {
  return `<div class="modal-form__inner">
    <div class="fz22 fw6 primary lh-2 mb24">Вы выбрали:</div>
    <div class="modal-form__inner-cover mb10" style="background-image: url(${dataCompany.photo});">
      <div class="modal-form__inner-icon">
        <svg class="w18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M9.216 15.6814L9.2175 15.6806L9.22125 15.678L9.2325 15.6694L9.27675 15.6375C9.31475 15.6098 9.3685 15.5693 9.438 15.516C9.576 15.4102 9.77175 15.2546 10.0054 15.0548C10.6187 14.5306 11.1921 13.9615 11.721 13.3522C12.9615 11.9175 14.25 9.87 14.25 7.5285C14.25 6.12975 13.6973 4.78725 12.7133 3.79725C12.2269 3.30724 11.6485 2.91826 11.0112 2.65272C10.3739 2.38718 9.69039 2.25031 9 2.25C8.30964 2.25026 7.62615 2.38707 6.98887 2.65255C6.35159 2.91803 5.77312 3.30693 5.28675 3.79688C4.30189 4.78921 3.74946 6.13078 3.75 7.52887C3.75 9.87 5.0385 11.9175 6.279 13.3522C6.80789 13.9615 7.38134 14.5306 7.99463 15.0548C8.22863 15.2546 8.424 15.4102 8.562 15.516C8.6297 15.5681 8.69808 15.6194 8.76713 15.6698L8.77913 15.678L8.7825 15.6806L8.784 15.6814C8.91338 15.7725 9.08663 15.7725 9.216 15.6814ZM10.875 7.5C10.875 7.99728 10.6775 8.47419 10.3258 8.82583C9.9742 9.17746 9.49728 9.375 9 9.375C8.50272 9.375 8.02581 9.17746 7.67418 8.82583C7.32254 8.47419 7.125 7.99728 7.125 7.5C7.125 7.00272 7.32254 6.52581 7.67418 6.17417C8.02581 5.82254 8.50272 5.625 9 5.625C9.49728 5.625 9.9742 5.82254 10.3258 6.17417C10.6775 6.52581 10.875 7.00272 10.875 7.5Z" fill="white" />
        </svg>
      </div>
    </div>

    <div class="fz18 fw6 mb4 lh-1">${dataCompany.name}</div>
    <div class="modal-form__inner-text mb20">${dataCompany.address}</div>
    <div class="box-params_text">
      <div class="aic jcb mb8">
        <div class="mr5 fs">Размер бокса:</div>
        <div class="box-param_text-decor"></div>
        <div class="fw6 primary ml5 fs">${box.sq} м2</div>
      </div>
      <div class="aic jcb mb8">
        <div class="mr5 fs">Срок Аренды:</div>
        <div class="box-param_text-decor"></div>
        <div class="fw6 primary ml5 fs">${state.term.name}</div>
      </div>
      <div class="aic jcb mb8">
        <div class="mr5 fs">Цена без скидки:</div>
        <div class="box-param_text-decor"></div>
        <div class="fw6 primary ml5 fs">${box.price} ₽</div>
      </div>
      <div class="aic jcb mb8">
        <div class="mr5 fs">Цена со скидкой:</div>
        <div class="box-param_text-decor"></div>
        <div class="fw6 primary ml5 fs">${box.price-profit} ₽</div>
      </div>
    </div>

    <div class="w-full py12 tac uppercase bg-grey fz18 fw7">Итого: ${total} ₽</div>

  </div>`
}


const book_modal = Modal({
  content: `<div class="row">
      <div class="col12--lg p20 px30--lg">
        <h2 class="fz28 mb14">Забронировать бокс</h2>
        <p class="mb24 fz14">Наш специалист перезвонит для подтверждения брони</p>
        <div data-form="true"></div>
      </div>
      <div class="col12--lg p20 px30--lg" data-summary="true"></div>
    </div>`,
  width: '860px',
})


const content = book_modal.getContentElement();
const summaryWrapper = content?.querySelector('[data-summary]')
const formWrapper = content?.querySelector('[data-form]')




export function CalcWidget() {
  if (!dataCompany) return null;
  const state: TState = { term: termData[0], sizeId: 0, box: dataCompany.boxes[0], storage: dataCompany.code };
  const sizeListeners: ((v: number) => void)[] = [];


  const containerParams = document.getElementById('boxParams');
  if (!containerParams) return;


  const handleClickBoxArea = (value: number) => {
    state.sizeId = value;
    state.box = dataCompany.boxes[state.sizeId]

    sizeListeners.forEach(l => l(state.sizeId))
    renderInfo()
    ////
  }
  const boxArea = BoxRender(dataCompany.boxes, handleClickBoxArea)
  boxArea?.setSize(state.sizeId)
  sizeListeners.push(v => boxArea?.setSize(v))




  const handleClickTerm = (value: TTerm) => {
    state.term = value;
    renderInfo()
    ////
  }
  TermsRender(handleClickTerm)


  const handleClickSize = (value: number) => {
    state.sizeId = value;
    state.box = dataCompany.boxes[state.sizeId]

    sizeListeners.forEach(l => l(state.sizeId))
    renderInfo()
    ////
  }
  const sr = SizesRender(dataCompany.boxes, handleClickSize)//'2,5м2'
  sizeListeners.push(v => sr?.setSize(v))



  BookBoxForm(state, formWrapper);


  containerParams.addEventListener('click', (e: any) => {
    if (e.target.classList.contains('btn-reservation')) {
      book_modal.open()
    }
  })



  function renderInfo() {
    if (!containerParams || !summaryWrapper || !formWrapper) return;

    let profit = Math.floor(state.box.price / 100 * state.term.discount), total = state.term.count * state.box.price - profit;
    summaryWrapper.innerHTML = renderSummary(state.box, profit, total, state)


    containerParams.innerHTML = `
    <div class="box-props">
      <div class="box-prop">
        <div class="fz24 mb4 fw7 primary">${boxContent[state.box.sq].size}</div>
        <div class="fz14">Размер бокса <span class="fz10" style="color:#6F6F6F">(д-ш-в)</span></div>
      </div>
      <div class="box-prop"><div class="fz24 mb4 fw7 primary">${boxContent[state.box.sq].cubic}</div><div class="fz14">Объем бокса</div></div>
      <div class="box-prop"><div class="fz24 mb4 fw7 primary">${boxContent[state.box.sq].door}</div><div class="fz14">Дверной проем</div></div>
    </div>

    <p class="fz18 fw6 mb12">В данной ячейке хватит места для хранения: </p>
    <div class="tags">${boxContent[state.box.sq].storeIn.map((e) => `<i>${e}</i>`).join('')}</div>

    <div class="calculate__footer">
      <div class="calculate__price">Ежемесячный платеж: <span class="calculate__price-amount">${profit > 0 ? `<del>${state.box.price} ₽</del>` : ''}${state.box.price - profit} ₽</span></div>
      <button class="btn btn-reservation">Забронировать бокс</button>
    </div>
  `
  }


  renderInfo()


}




// <input type="hidden" name="form" value="feedbackForm"/>
// <p className="box-description__advantage">${ boxContent[box.sq].advantage }</p>
